module.exports = __webpack_public_path__ + "img/clue03_bg.f5ba48f1.png";